import { render, staticRenderFns } from "./paymentDetail.vue?vue&type=template&id=61db4a85&"
import script from "./paymentDetail.vue?vue&type=script&lang=ts&"
export * from "./paymentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./paymentDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports